import Marquee from "react-fast-marquee";
import { Quote } from "lucide-react";
import SectionHeader from "@/components/SectionHeader";

const TESTIMONIALS = [
  { text: "Consistent quality across every delivery — the linen presentation in our rooms has noticeably improved.", role: "Hotel Procurement Team" },
  { text: "Reliable supply and professional communication. Requirements are understood and handled without follow-ups.", role: "Resort Procurement Team" },
  { text: "The towels hold up beautifully to daily institutional laundering. Exactly what we needed.", role: "Hospitality Customer" },
  { text: "Custom sizes were produced to our exact specification — a real advantage for our property.", role: "Serviced Apartments Operator" },
  { text: "Well-finished products, on-time dispatch and dependable service, order after order.", role: "Institutional Buyer" },
  { text: "From bed linen to bath robes, one dependable partner for our complete textile requirement.", role: "Hotel Operations Team" },
  { text: "Professional B2B experience end to end — clear specifications, quality products, smooth supply.", role: "Hospitality Distributor" },
];

const Testimonials = () => (
  <section data-testid="testimonials-section" className="py-24 md:py-32 bg-linen/40 border-y border-navy/10 overflow-hidden">
    <div className="max-w-[1400px] mx-auto px-6 md:px-12">
      <SectionHeader
        number="—"
        eyebrow="What Our Customers Say"
        title="Trusted Voices from the Industry"
        align="center"
      />
    </div>
    <div className="mt-16">
      <Marquee speed={40} gradient={false} pauseOnHover>
        {TESTIMONIALS.map((t, i) => (
          <div
            key={t.role + i}
            data-testid={`testimonial-card-${i}`}
            className="w-[340px] md:w-[420px] mx-4 bg-ivory border border-navy/10 p-8 md:p-10 flex flex-col"
          >
            <Quote size={22} strokeWidth={1.5} className="text-gold" />
            <p className="font-serif text-lg md:text-xl text-navy/85 leading-relaxed mt-5">
              "{t.text}"
            </p>
            <div className="flex items-center gap-3 mt-6">
              <span className="h-px w-8 bg-gold/60" />
              <span className="text-[11px] tracking-[0.22em] uppercase text-navy/55">{t.role}</span>
            </div>
          </div>
        ))}
      </Marquee>
    </div>
  </section>
);

export default Testimonials;
